export const EmailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const NumberRegx = /^\d+$/;
export const NumberRegxWithDecimal = /^(?!0(\.0+)?$)(\d*\.?\d*)$/;
export const isValidName = /^[A-Za-z._\s]+$/;
export const phoneNumberRegex = /^[+\d](?:.*\d)?$/;
export const contactPersonRegex =
  /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/'`~ ]*$/;
// Min 8 chars with at least one lowercase, uppercase, number and special
// character, and no whitespace.
export const passwordRegex =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/;
